import { Component, OnInit, Input, Output, EventEmitter, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { TreeNode, TreeOptions, TreeService } from '@mydocma/component-library/src/lib/tree';
import { Structure } from '../structure.model';
import { MediatorService } from '@mydocma/core';
import { CoEvent, CoEventService } from '@mydocma/co';
import { AppContainerService } from '@mydocma/app-container';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { distinctUntilChanged, filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'mydocma-structure-tree',
  templateUrl: './structure-tree.component.html',
  styleUrls: ['./structure-tree.component.scss']
})
export class StructureTreeComponent implements OnInit, OnDestroy {

  @Input() treeOptions: TreeOptions;

  @Input() structuresTree;

  @Input() selectedStructureTreeNode;

  @Output()
  structureClick = new EventEmitter<Structure>();

  @ViewChild('mydocmaTreeElement', {static: true}) mydocmaTreeElement: ElementRef

  highlightClass = 'mydocma-tree-search-highlight';
  treeService: TreeService;

  constructor(
    private readonly mediatorService: MediatorService,
    private readonly CoEventService: CoEventService,
    private readonly appContainerService: AppContainerService,
  ) {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    if ( typeof(this.treeOptions) === 'undefined' ) {
      this.treeOptions = {
          collapseAllTopLevel: 1,
          suppressChildrenCount: true,
          getNodeChildren: (node) => node.data.children,
          getNodeInfo: (node) => {
            return {
              text: `${node.data.name} - ${node.data.desc}`,
              expanded: true,
            }
          },
          onReady: (treeService, treeApi) => {
            this.treeService = treeService;
            this.CoEventService.emit(CoEvent.StructureTreeReady, treeApi);

            this.appContainerService.isLeftPaneOpen
              .pipe(
                untilDestroyed(this),
                distinctUntilChanged(),
                filter(isOpen => isOpen),
              )
              .subscribe(() => {
                setTimeout(() => {
                  this.treeService?.gridApi?.sizeColumnsToFit();
                }, 100);
              });
          }
      };
    }
    if (this.treeOptions && !this.treeOptions.collapseAllTopLevel) {
      this.treeOptions.collapseAllTopLevel = 1;
    }
  }

  public onClick(node: TreeNode) {
    if (node) {
      this.structureClick.emit(node.data);
    }
  }

}
